import React from "react";

function Search(props) {

  const handleOnFocus = () => {
    document.body.style.overflow = "hidden";
    props.setIsSearchSalons(true)
  }

  return (
    <div className="search-salons-container">
      <div onClick={()=>{handleOnFocus()}} className="search-salons d-flex justify-content-start align-items-center">
        <input
          className="border-0 w-100"
          placeholder="Salon name, Category or Service"
          onFocus={() => { handleOnFocus() }}
        />
        <button className="border-0 bg-white" onClick={()=>{handleOnFocus()}}><img src="/assets/common/search_icon.svg" alt="Search" /></button>
      </div>
    </div>
  );
}

export default Search
